import "./src/styles/global.css"
import wrap from "./wrap"

export const wrapRootElement = wrap